import { render, staticRenderFns } from "./Database.vue?vue&type=template&id=cbe566c0"
import script from "./Database.vue?vue&type=script&lang=js"
export * from "./Database.vue?vue&type=script&lang=js"
import style0 from "./Database.vue?vue&type=style&index=0&id=cbe566c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports